/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface LanguageInfo
 */
export interface LanguageInfo {
  /**
   *
   * @type {number}
   * @memberof LanguageInfo
   */
  etelLanguage: number
  /**
   *
   * @type {string}
   * @memberof LanguageInfo
   */
  isoCode: string
}

/**
 * Check if a given object implements the LanguageInfo interface.
 */
export function instanceOfLanguageInfo(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'etelLanguage' in value
  isInstance = isInstance && 'isoCode' in value

  return isInstance
}

export function LanguageInfoFromJSON(json: any): LanguageInfo {
  return LanguageInfoFromJSONTyped(json, false)
}

export function LanguageInfoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LanguageInfo {
  if (json === undefined || json === null) {
    return json
  }
  return {
    etelLanguage: json['etelLanguage'],
    isoCode: json['isoCode'],
  }
}

export function LanguageInfoToJSON(value?: LanguageInfo | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    etelLanguage: value.etelLanguage,
    isoCode: value.isoCode,
  }
}
